(() => {
/**
 * @file
 * Show hidden rows
 *
 */ (function($) {
    Drupal.behaviors.marketAreas = {
        attach: function(context, settings) {
            const url = new URL(location.href);
            const cr = url.searchParams.get("cr") === "true" ? true : false;
            $("#block-treston-marketsregionsbar .close-button", context).on("click", function() {
                $(".responsive-w.thing-wrapper").removeClass("with-market-region-bar");
                $("#block-treston-marketsregionsbar").removeClass("visible");
                $7cd4002cc93c5845$var$setCookie("market-region-notice-closed", true, 30);
            });
            if (url.searchParams.get("manual-redirect") == "true") {
                console.log("Manual redirect");
                $7cd4002cc93c5845$var$setCookie("market-region-manually-redirected", true, 30);
                $("#block-treston-marketsregionsbar").removeClass("visible");
            }
            console.log($7cd4002cc93c5845$var$getCookie("market-region-notice-closed"));
            console.log($7cd4002cc93c5845$var$getCookie("market-region-manually-redirected"));
            if ($7cd4002cc93c5845$var$getCookie("market-region-notice-closed") != "true" && $7cd4002cc93c5845$var$getCookie("market-region-manually-redirected") != "true") {
                console.log("Let's do this again");
                $.get("/marketregion/get-market-region?ssid=23Dts923-" + new Date().getTime(), function(data) {
                    var jsonData = data;
                    var isFront = $("BODY").hasClass("path-frontpage");
                    console.log(isFront);
                    if (jsonData.language === "en-us" && jsonData.country !== "US") {
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    } else if (jsonData.language === "en" && jsonData.country === "US") {
                        if (isFront) window.location.href = "https://www.treston.us?cr=true"; // cr => country redirected
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    } else if (cr == true) {
                        $("#block-treston-marketsregionsbar .content .message").html(jsonData.content);
                        $(".responsive-w.thing-wrapper").addClass("with-market-region-bar");
                        $("#block-treston-marketsregionsbar").addClass("visible");
                    }
                });
            }
        }
    };
})(jQuery);
function $7cd4002cc93c5845$var$setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function $7cd4002cc93c5845$var$getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

})();
//# sourceMappingURL=market-regions.js.map
